export default {
  'GUEST' (state) {
    return state.guest
  },
  'GUESTS' (state) {
    return state.guests
  }
}
